<template>
  <div>
    <div @click="close()" class="menuModal"></div>
    <div class="menuModal--inner">
      <div class="row form-inline">
        <div class="col-sm-6">
          <table-length @changeRowPerPage="changeRowPerPageCount" />
        </div>
        <div class="col-sm-6">
          <div id="datatable_filter" class="dataTables_filter">
            <label
              >{{ $t('common.search') }}:
              <input
                v-model="searchString"
                @keyup="searchWord"
                type="search"
                class="form-control input-sm"
                placeholder=""
                aria-controls="datatable"
              />
            </label>
          </div>
        </div>
      </div>
      <app-table
        :column-titles="tableHeaderColumns"
        :display-items="displayItems"
        @sortTable="sortTable"
        @buttonClickEvent="buttonClickEvent"
      />
      <pagination
        :page-par-item-count="displayItemPerPageCount"
        :total-item-count="totalItemCount"
        :current-page="currentPage"
        @changePage="changePage"
      />
    </div>
  </div>
</template>
<script>
// components
import Table from '@/components/common/table/Table'
import Pagination from '@/components/tabale/Pagination'
import TableLength from '@/components/tabale/TableLength'
// mixin
import list from '@/mixin/list'
// store
import { mapGetters } from 'vuex'

export default {
  components: {
    AppTable: Table,
    Pagination,
    TableLength,
  },
  mixins: [list],
  data() {
    return {
      tableHeaderColumns: [
        this.$t('common.itemCode'),
        this.$t('common.itemName'),
        this.$t('common.manufacturingCategory'),
        this.$t('common.topping'),
        this.$t('common.select'),
      ],
      displayItems: [],
      searchString: '',
    }
  },
  computed: {
    ...mapGetters({
      items: 'menu/getItems',
      language: 'settings/getLanguage',
    }),
  },
  mounted() {
    this.fetchItems = this.items.map((item) => {
      return [
        item.itemCode,
        item.names[this.language],
        item.itemKind.name,
        Object.values(item.toppings).join(','),
        { type: 'itemAdd', id: item.itemCode },
      ]
    })
    this.allItems = this.fetchItems
    this.totalItemCount = this.allItems.length
    this.displayItems = this.allItems.slice(0, this.displayItemPerPageCount)
  },
  methods: {
    buttonClickEvent: function(type, id) {
      this.$store.dispatch('menu/addMenuItem', {
        itemCode: id,
        language: this.language,
      })
    },
    close: function() {
      this.$store.dispatch('menu/updateIsShowItemSelectModal', false)
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },
  },
}
</script>
<style>
.menuModal {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: fixed;
}
.menuModal--inner {
  position: absolute;
  width: 800px;
  top: 35px;
  left: calc(100% - 800px);
  margin-left: -300px;
  background-color: #fff;
  padding: 25px;
  box-sizing: border-box;
}
</style>
